// extracted by mini-css-extract-plugin
export default {"ProjectLogoPlaceholder":"ProjectLogoPlaceholder_ProjectLogoPlaceholder__JOBrl"};